import { TbCreditCard, TbGift, TbSparkles } from "react-icons/tb";
import { ShortcutCard } from "../../../../Components/Atoms/ShortcutCard";

const SECTIONS = [
  { id: "cartoes", label: "Cartões", icon: TbCreditCard },
  { id: "beneficios", label: "Benefícios", icon: TbGift },
  { id: "virtuais", label: "Virtuais", icon: TbSparkles },
];

export const CartoesQuickActions = ({ activeSection, onSectionChange }) => (
  <section className="mb-5 min-w-0 overflow-hidden">
    <p className="dashboard-section-label mb-3">
      Ações rápidas
    </p>
    <div className="shortcut-scroll-row">
      {SECTIONS.map(({ id, label, icon }) => (
        <ShortcutCard
          key={id}
          icon={icon}
          label={label}
          active={activeSection === id}
          onClick={() => onSectionChange(id)}
        />
      ))}
    </div>
  </section>
);
